module.exports = __webpack_public_path__ + "static/undraw_Cloud_docs_re_xjht-ef69654274b31ba598a03b07abc5380f.svg";